<template>
  <pp-modal v-model="showModal" :mask-closable="false" width="450" :closable="false">
    <div class="modalhead">
        <div class="">{{$t("components.global.flowDetail")}}</div>
        <div class="secondTitle">{{$t("components.global.flowId")}}: {{detailList.fundFlowId}}</div>
    </div>
    <div class="content">
        <div class="line">
            <div class="fl">{{$t("components.global.businessType")}}: </div>
            <div class="fr">{{this.$filters.getFondTypeName(detailList.fundType, locales)}}</div>
        </div>
        <div class="line">
            <div class="fl" v-if="detailList.transactionType === 'REFUND'">{{$t("components.global.inComingTime")}}:</div>
            <div class="fl" v-else>{{$t("components.global.recordedTime")}}</div>
            <div class="fr">{{this.$filters.timestampToDatetime(detailList.created)}}</div>
        </div>
        <div class="line">
            <div class="fl" v-if="detailList.transactionType === 'REFUND'">{{$t("components.global.orderOriginAmount")}}</div>
            <div class="fl" v-else>{{$t("components.global.orderOriginAmount")}}</div>
            <div class="fr">{{detailList.originalAmount}} {{detailList.originalCurrency}}</div>
        </div>
        
        <div class="line" v-if="detailList.originalCurrency != detailList.currency">
            <div class="fl" >{{$t("components.global.exchangeRate")}}</div>
            <div class="fr">1 {{detailList.originalCurrency}}={{detailList.fxRate}} {{detailList.currency}}</div>
        </div>
        <div class="line" >
            <div class="fl" v-if="detailList.transactionType === 'REFUND'">{{$t("components.global.refundAmount")}}</div>
            <div class="fl" v-else>{{$t("components.global.recordedAmount")}}</div>
            <div class="fr" v-if="detailList.transactionType === 'REFUND'">{{detailList.debitAmount}} {{detailList.currency}}</div>
            <div class="fr" v-else>{{detailList.creditAmount}} {{detailList.currency}}</div>
        </div>
    </div>
    <div slot="footer" class="textright">
        <pp-button class="modal-btn" type="primary"  size="spec" @click="sure" >{{$t("components.global.confirm")}}</pp-button>
    </div>
  </pp-modal>

</template>
<script>
    export default {
        name: 'DetailModal',
        props: {
            showModal: false,
            detailList: null
        },
        mounted() {},
        data() {
            return {
                locales: this.$i18n.locale
            }
        },
        methods: {
            sure(){
                this.$emit('canle')
            },
        }
    }



</script>
<style lang="scss" scoped>
.modalhead{
        display: block;
    width: 100%;
    height: 60px;
    line-height: 30px;
    font-size: 20px;
    color: #1c2438;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}
.textright .modal-btn{
    padding: 6px 20px;
      height: 32px;
      text-align: center;
      font-size: 14px;
}
.secondTitle{
    color:#000;
    font-size:14px;
    height: 18px;
    line-height: 18px;
    text-align:left;
    filter: alpha(opacity=56);
    -moz-opacity: 0.56;
    -khtml-opacity: 0.56;
    opacity: 0.56;
    margin-bottom: 4px;
}
.modalContent{
    text-align:left;
    font-size:14px;
}
.content{
    width: 100%;
    .line{
        height: 20px;
        font-size: 14px;
        line-height: 20px;
        margin-top: 16px;
    }
    .bankline{
        margin-top: 16px;
        height: 70px;
        img{
            float: left;
            display: block;
            width: 64px;
            height: 64px;
        }
        .info{
            height: 64px;
            float: left;
            margin: 0 0 0 41px; 
            div{
                height: 32px;
                line-height: 32px;
            }
        }
        
    }
}


</style>
